import React from 'react';
import PropTypes from 'prop-types';
import { property } from 'underscore';

import { searchCampaignCreationStepConfigs } from '../steps/step-configs';
import { getCampaignCreationStepListConfig, getSearchCampaignCreationFlow, SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS } from '../steps/step-utils';
import { CreationWizard } from './creation-wizard';

export const SearchCampaignCreationWizard = props => (
  <CreationWizard
    stepConfigs={searchCampaignCreationStepConfigs(props.permissions)}
    getStepListConfig={getCampaignCreationStepListConfig}
    scenarioName="SearchCampaignCreationV2"
    activityName="SearchCampaignWizard"
    wizardLoggerFlowName="SearchCampaign"
    wizardLoggerSubFlowName="SearchCampaignCreation"
    wizardLoggerStepToPage={SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS}
    perfMarkerName="SearchCampaignCreationWizard"
    onDoneNavigateToSiteMapId="campaigns"
    getFlow={getSearchCampaignCreationFlow}
    initialFlowFactors={{
      showExtensions: property(['permissions', 'dynamic', 'SearchRevampPhase1Post'])(props),
    }}
    dynamicOptions={props.dynamicOptions}
    isLegalFooter
    {...props}
  />
);

SearchCampaignCreationWizard.propTypes = {
  dynamicOptions: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
